import { ResponsibleParty } from '../types/RoleTypes';

/**
 * Gets the display name for a responsible party
 * @param party - The responsible party (User or Group)
 * @returns The full name for users, group name for groups, or fallback values
 */
export const getPartyName = (party: ResponsibleParty): string => {
  if (party?.__typename === 'User') {
    const { firstName, lastName, login } = party;
    const fullName = [firstName, lastName].filter(Boolean).join(' ');
    return fullName || login || 'Unknown User';
  }
  if (party?.__typename === 'Group') {
    return party?.name || 'Unknown Group';
  }
  return 'Unknown Party';
};

/**
 * Gets the secondary text to display for a responsible party
 * @param party - The responsible party (User or Group)
 * @returns The login for users, "AD Group" for groups, or undefined for unknown parties
 */
export const getPartySecondaryText = (
  party: ResponsibleParty,
): string | undefined => {
  if (party?.__typename === 'User') {
    return party?.login || undefined;
  }
  if (party?.__typename === 'Group') {
    return 'AD Group';
  }
  return undefined;
};
